import axios from 'axios';
import * as types from '@/store/mutation-types';
import type {RootState} from '@/types/RootState';
import {performApiRequest} from '@/store/helpers/vuex-helpers';
import type {Module} from 'vuex';
import {handleApiError} from '@/utils/errorHandler.ts';

export interface TagState {
    loading: Record<string, boolean>;
    tags: Record<string, number>;
}

// state
const state: TagState = {
    loading: {
        fetch_tags: false,
        create_tag: false,
        remove_tag: false,
    },
    tags: {},
};


const mutations = {
    [types.SET_TAGS_LOADING](state: TagState, loading: { subject: string, loading: boolean }) {
        state.loading[loading.subject] = loading.loading;
    },
    [types.SET_TAGS](state: TagState, tags) {
        state.tags = tags;
    },
};

const actions = {

    async fetchTags({commit}, {forType}) {
        const query = forType ? `?for=${forType}` : '';
        const responseData = await performApiRequest(commit, 'SET_TAGS_LOADING', 'fetch_tags', () => axios.get(`/v1/tags${query}`));
        commit(types.SET_TAGS, responseData.tags);
    },

    async createTag({commit}, data: { name: string, forType: string, forId: string }) {
        try {
            await performApiRequest(commit, 'SET_TAGS_LOADING', 'create_tag', () => axios.post('/v1/tags', data));
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    },

    async removeTag({commit}, data: { name: string, customer_id: string }) {
        try {
            await performApiRequest(commit, 'SET_TAGS_LOADING', 'remove_tag', () => axios.post('/v1/tags/remove', data));
        } catch (error) {
            handleApiError(error);
        }
    },
};

const tagsModule: Module<TagState, RootState> = {
    namespaced: true,

    state,

    getters: {
        loading: (state: TagState) => state.loading,
        tags: (state: TagState) => state.tags,
    },

    mutations,

    actions,
}

export default tagsModule;
